import dayjs from 'dayjs';
import 'dayjs/locale/en-au';
import 'dayjs/locale/en-gb';
import 'dayjs/locale/en-ie';
import 'dayjs/locale/es';
import 'dayjs/locale/de';
import 'dayjs/locale/de-ch';
import 'dayjs/locale/fr';
import 'dayjs/locale/it';
import dayjsBusinessDays from 'dayjs-business-days';

dayjs.extend(dayjsBusinessDays);
const changeDayjsLocale = locale => {
  switch (locale) {
    case 'de-ch':
      return 'de-ch';
    case 'de-de':
      return 'de';
    case 'es-es':
      return 'es';
    case 'fr-be':
      return 'fr';
    case 'fr-fr':
      return 'fr';
    case 'it-it':
      return 'it';
    default:
      return 'en';
  }
};

const calculateDateEstimateRange = (deliveryEstimate, locale) => {
  const { minDeliveryDays, maxDeliveryDays } = deliveryEstimate;
  dayjs.locale(changeDayjsLocale(locale));
  const businessDays = 1;

  const firstDate = dayjs()
    .businessDaysAdd(businessDays)
    .businessDaysAdd(minDeliveryDays);

  const secondDate = dayjs()
    .businessDaysAdd(businessDays)
    .businessDaysAdd(maxDeliveryDays);

  const isSameMonth = firstDate.isSame(secondDate, 'month');

  return `${firstDate.format('MMMM D')} - ${secondDate.format(
    isSameMonth ? 'D' : 'MMMM D'
  )}`;
};

export default calculateDateEstimateRange;
